export const DEFAULT_CONTENT_TYPE_HEADER = { 'Content-Type': 'application/json' };
export const DEFAULT_ACCEPT_HEADER = { Accept: 'application/json' };

export const DEFAULT_HEADER = {
  ...DEFAULT_ACCEPT_HEADER,
  ...DEFAULT_CONTENT_TYPE_HEADER,
};
